import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileModel } from '@ca/core/models';
import { FileDownloadService, FilePreviewService, WindowRef } from '@ca/core/services';
import { ArivisService } from 'src/app/core/services/arivis.service';
import * as FileUtils from '../../../../utils/file/file-utils';

@Component({
    selector: 'ca-file-item',
    templateUrl: './file-item.component.html',
    styleUrls: ['./file-item.component.scss'],
})
export class FileItemComponent implements OnInit {
    @Input() file: FileModel;
    @Input() isDisabled: boolean = false;
    @Input() preview: boolean = true;
    @Input() download: boolean = false;
    @Input() removeFiles: boolean = false;
    @Input() useTrashIcon: boolean = false;
    @Output() onRemoveSelection: EventEmitter<FileModel> = new EventEmitter<FileModel>();
    @ViewChild('filePreview') filePreviewElement: ElementRef;
    viewerUrl: string;

    constructor(
        private filePreviewService: FilePreviewService,
        private arivisService: ArivisService,
        private fileDownloadService: FileDownloadService,
        private windowRef: WindowRef,
    ) {}

    ngOnInit(): void {
        if (!this.file.viewerUrl) {
            if (this.file.storageType === 'Azure') {
                this.viewerUrl = this.arivisService.generateArivisMlViewerUrl(this.file);
            }
        } else {
            this.viewerUrl = this.file.viewerUrl;
        }
    }

    remove(file: FileModel): void {
        if (this.onRemoveSelection) {
            this.onRemoveSelection.emit(file);
        }
    }

    isSupportedByArivis(file: FileModel): boolean {
        if (file.storageType === 'Web') {
            return false;
        }
        return this.arivisService.isSupportedByArivis(file.type);
    }

    isSupportedByFilePreviewer(file: FileModel): boolean {
        if (file.storageType === 'Web') {
            return false;
        }

        return this.arivisService.isSupportedByFilePreviewer(file.type);
    }

    previewOutput(): void {
        // Necessary due to https://github.com/ng-bootstrap/ng-bootstrap/issues/1604#issuecomment-359425286
        this.filePreviewElement.nativeElement.ownerDocument.activeElement.blur();

        if (this.file && this.file.token) {
            this.filePreviewService.openWithURL(this.file.token, FileUtils.getFileExtension(this.file.token));
        }
    }

    openViewer(): void {
        this.windowRef.nativeWindow.open(this.viewerUrl, '_blank');
    }

    downloadFile(): void {
        this.fileDownloadService.downloadFile(this.file.token, this.file.name).subscribe();
    }
}
